var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.credentials ? _c('div', [_c('div', {
    staticClass: "utxo_label"
  }, [_vm._v("Signature")]), _vm._l(_vm.credentials, function (credential, i) {
    return _c('p', {
      key: i,
      staticClass: "monospace signature"
    }, [_vm._v(" " + _vm._s(credential.signature) + "> ")]);
  })], 2) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }